/**
 * 数据字典工具类
 */
import { useCommonStore } from '/@/store/modules/common'

/**
 * 获取字典选项列表
 * @param dictType 字典类型
 * @returns 字典选项列表
 */
export const getDictOptions = (dictType: string) => {
  const commonStore = useCommonStore()
  const dictionary = commonStore.dictionary
  if (!dictionary.find((item) => item.value === dictType)) {
    return []
  }
  const dictOptions = dictionary.find((item) => item.value === dictType).children
  if (!dictOptions) {
    console.error('缺少字典字段：' + dictType)
    return []
  }
  return dictOptions
}

/**
 * 获得字典数据的文本展示 即Label
 * @param dictType 字典类型
 * @param value 字典数据的值
 * @return 字典名称
 */
export const getDictLabel = (dictType: string, value: any): string => {
  const commonStore = useCommonStore()
  const dictionary = commonStore.dictionary
  const dictOptions = dictionary.find((item) => item.value === dictType).children
  if (!dictOptions) {
    console.error('缺少字典字段：' + dictType)
    return ''
  }
  const dictLabel = ref('')
  dictOptions.forEach((dict: any) => {
    if (dict.value === value) {
      dictLabel.value = dict.label
    }
  })
  return dictLabel.value
}

// 为了支持 TypeScript 类型提示，添加全局属性声明
declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $getDictOptions: typeof getDictOptions
    $getDictLabel: typeof getDictLabel
  }
}
